// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","base":"App_base__AXKy3","navigationRailContainer":"App_navigationRailContainer__9Opx9"};